import React from 'react';
import PropTypes from 'prop-types';

const DeviceLandscapePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M25.009 8A2.993 2.993 0 0 1 28 11.01v9.98A3.002 3.002 0 0 1 25.009 24H6.99A2.993 2.993 0 0 1 4 20.99v-9.98A3.002 3.002 0 0 1 6.991 8H25.01zM8 22V10h16v12H8z"
    />
  );
};

DeviceLandscapePath.propTypes = {
  fill: PropTypes.string,
};

export default DeviceLandscapePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/device-landscape.jsx